<template>
  <div class="modal">
    <div class="modal-content" :class="'modal-' + modalType">
      <div v-if="modalHeader" class="modal-header">
        <h2>{{ modalHeader }}</h2>
        <button v-if="hasCloseButton" @click="$emit('close')" class="button button-icon button-inverted-secondary">
          &#215;
        </button>
      </div>
      <div class="modal-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loading',
  props: {
    modalHeader: {
      type: String,
      default: null
    },
    hasCloseButton: {
      type: Boolean,
      default: false
    },
    modalType: {
      type: String,
      default: 'normal'
    }
  }
}
</script>
